import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DrugItem,
  TopDrug,
  FirstCategoryLevel,
  SecondCategoryLevel,
  ThirdCategoryLevel
} from 'src/api/types';
import cn from 'classnames';
import { containerWithBackgroundImageStyle } from 'src/styles/shared';
import trns from '../trns';

interface Props {
  drugList: DrugItem[] | TopDrug[];
  selectedFirstLevelCategory?: FirstCategoryLevel;
  selectedSecondLevelCategory?: SecondCategoryLevel;
  selectedThirdLevelCategory?: ThirdCategoryLevel;
  textSearch?: string;
}

const DrugTable: FC<Props> = ({
  selectedFirstLevelCategory,
  selectedSecondLevelCategory,
  selectedThirdLevelCategory,
  drugList,
  textSearch
}) => {
  return (
    <div
      style={containerWithBackgroundImageStyle}
      className="relative px-4 lm:px-0"
    >
      <div className="w-full compendium-constraints pt-2 pb-5 lm:pb-20">
        <h2 className="fs-header5-bold text-darkBlue mb-6 lm:mb-12 uppercase">
          {textSearch ? (
            <FormattedMessage
              {...trns.drugInCity}
              values={{
                tradeName: textSearch
              }}
            />
          ) : (
            <FormattedMessage {...trns.categoryPrice} />
          )}
          {selectedFirstLevelCategory &&
            !selectedSecondLevelCategory &&
            !selectedThirdLevelCategory &&
            ` ${selectedFirstLevelCategory.name}`}

          {selectedSecondLevelCategory &&
            selectedFirstLevelCategory &&
            ` ${selectedFirstLevelCategory.name} / ${selectedSecondLevelCategory.name}`}

          {selectedThirdLevelCategory &&
            selectedFirstLevelCategory &&
            ` ${selectedFirstLevelCategory.name} / ${selectedThirdLevelCategory.name}`}
        </h2>
        <div className="flex flex-col bg-white compendium-rounded-14 overflow-hidden border border-astronautBlue">
          <div
            className={cn(
              'flex justify-between pb-3 pt-3 pr-5 pl-5 rounded-t-14 bg-astronautBlue',
              'sm:pr-12 sm:pl-12'
            )}
          >
            <p className="fs-body-bold text-white">
              <FormattedMessage {...trns.name} />
            </p>
            <p className="fs-body-bold text-white text-right whitespace-nowrap">
              <FormattedMessage {...trns.price} />
            </p>
          </div>
          <div className="pt-2 pb-2">
            {drugList
              ?.slice(0, 4)
              .map((drugItem: DrugItem | TopDrug, index) => {
                return (
                  <div
                    key={index}
                    className={cn(
                      'flex justify-between pb-3 pt-3 pr-5 pl-5 items-center',
                      'sm:pr-12 sm:pl-12'
                    )}
                  >
                    <p className="fs-caption-reg text-shuttleGray pr-5">
                      {drugItem.name}
                    </p>
                    <p className="text-vermilion fs-body-bold text-right whitespace-nowrap">{`${
                      drugItem.minPrice?.toFixed(2) || '0.00'
                    } - ${drugItem.maxPrice?.toFixed(2) || '0.00'} ₴`}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrugTable;
